import reservee_form__rules from "../../../validation/scenarios/reservee_form__rules";

export default {
        'reservees'  : [(m) => {
            if (m.length <= 0) {
                return "Please add at least one renter!";
            }
            if (m.some(r => !r.full_name)) {
                return "Please fill all renters info!";
            }
            return true;
        }],
        'reservees.*': reservee_form__rules
};
